module.exports = __webpack_public_path__ + "media/featured/Today-6674b00d.png";